import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetContrapartidas", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  var contrapartidas = {
    data: [],
    meta: {},
  };

  await services.contrapartidas.get_all(search).then((res) => {
    contrapartidas = res.data;
  });
  return contrapartidas;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.contrapartidas.show({ id: id }).then((res) => {
    dispatch("ActionSetContrapartida", res.data.contrapartidas_modelos);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.contrapartidas.store(payload).then((res) => {
    commit(types.SET_CONTRAPARTIDA, res.data.contrapartidas_modelos);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.contrapartidas
    .update({ id: payload.id }, payload)
    .then((res) => {
      commit(types.SET_CONTRAPARTIDA, res.data.contrapartidas_modelos);
    });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.contrapartidas.delete({ id: id }).then(() => {
    commit(types.SET_CONTRAPARTIDA, null);
  });
};

export const ActionSetContrapartidas = ({ commit }, payload) => {
  commit(types.SET_CONTRAPARTIDAS, payload);
};

export const ActionSetContrapartida = ({ commit }, payload) => {
  commit(types.SET_CONTRAPARTIDA, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewContrapartida = ({ commit }) => {
  commit(types.SET_CONTRAPARTIDA, {});
};
